var v = Object.defineProperty, c = Object.defineProperties;
var x = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var s = (t, o, a) => o in t ? v(t, o, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[o] = a, i = (t, o) => {
  for (var a in o || (o = {}))
    m.call(o, a) && s(t, a, o[a]);
  if (e)
    for (var a of e(o))
      p.call(o, a) && s(t, a, o[a]);
  return t;
}, l = (t, o) => c(t, x(o));
var f = (t, o) => {
  var a = {};
  for (var r in t)
    m.call(t, r) && o.indexOf(r) < 0 && (a[r] = t[r]);
  if (t != null && e)
    for (var r of e(t))
      o.indexOf(r) < 0 && p.call(t, r) && (a[r] = t[r]);
  return a;
};
import { jsx as u, Fragment as P } from "react/jsx-runtime";
import "react";
import { f as g, k as y } from "./factory-ueRxoNOV.js";
import { P as O } from "./Portal-CZ-iZqfA.js";
const d = {
  app: 100,
  modal: 200,
  popover: 300,
  overlay: 400,
  max: 9999
};
function Z(t) {
  return d[t];
}
const j = g(
  (k, r) => {
    var n = k, { withinPortal: t = !0, children: o } = n, a = f(n, ["withinPortal", "children"]);
    return y() === "test" || !t ? /* @__PURE__ */ u(P, { children: o }) : /* @__PURE__ */ u(O, l(i({ ref: r }, a), { children: o }));
  }
);
j.displayName = "@mantine/core/OptionalPortal";
export {
  j as O,
  Z as g
};
